import { StatusBar } from "expo-status-bar";
import { Platform, StyleSheet } from "react-native";
import Stats from "../../components/Accounts/Stats";
import ErrorBoundary from "../../components/ErrorBoundary";
import { View } from "../../components/Themed";

export default function StatsScreen() {
  return (
    <View style={styles.container}>
      <ErrorBoundary>
        <Stats />
      </ErrorBoundary>
      <StatusBar style={Platform.OS === "ios" ? "light" : "auto"} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  accountsList: {
    width: "100%",
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
  },
  separator: {
    marginVertical: 30,
    height: 1,
    width: "80%",
  },
});
